/* eslint-disable */

// Как работает cadesplugin api - https://cpdn.cryptopro.ru/content/cades/plugin-activation.html
// Методы и свойства плагина - https://cpdn.cryptopro.ru/content/cades/plugin-methods.html

import {
  BrowserSpecs,
  PluginLoadedEvent,
  CadespluginFunc,
  PluginObject,
  PluginException,
  CadesPluginAsync,
} from "./types";

/**
 *  Функция для взаимодействия с расширением CryptoPro Extension. Возвращает промис с необходимыми методами.
 *  Промис используется для того, чтобы дождаться инициализации расширения и его работы с криптопровайдером.
 */
// prettier-ignore
export const cadesplugin: CadespluginFunc = function ( // NOSONAR
  isPluginInstalledCallback?: (isInstalled: boolean) => void
): CadesPluginAsync | undefined {
  if ("cadesplugin" in window) {
    return;
  }
  let pluginObject: Partial<PluginObject>;
  let isPluginResolved: boolean;
  let pluginReject: (msg: string | undefined | object) => void;
  let pluginResolve: (value?: PromiseLike<never>) => void;
  let isOpera: boolean;
  let isFireFox: boolean;
  let isSafari: boolean;
  let isYandex: boolean;
  let isCadespluginInstalled: boolean = false;
  let isCadespluginLoadedEventRecieved: boolean = false;
  const textJavascript: string = "text/javascript";
  let cadesplugin: Partial<CadesPluginAsync>;

  cadesplugin = new Promise((resolve, reject) => {
    pluginResolve = resolve as (value?: PromiseLike<never>) => void;
    pluginReject = reject;
  });

  /**
   *  Функция проверки браузера пользователя. Возвращает название браузера и версию.
   */
  function checkBrowser() {
    const userAgent = navigator.userAgent;
    let match =
      userAgent.match(/(opera|yabrowser|chrome|safari|firefox)\/?\s*(\d+)/i) ||
      [];
    let secondaryMatch: RegExpMatchArray | null | string;
    if (match[1] === "Chrome") {
      secondaryMatch = userAgent.match(/\b(OPR|Edg|YaBrowser)\/(\d+)/);
      if (secondaryMatch != null) {
        return {
          name: secondaryMatch[1].replace("OPR", "Opera"),
          version: secondaryMatch[2],
        };
      }
    }
    match = match[2]
      ? [match[1], match[2]]
      : [navigator.appName, navigator.appVersion, "-?"];
    if ((secondaryMatch = userAgent.match(/version\/(\d+)/i)) != null) {
      match.splice(1, 1, secondaryMatch[1]);
    }
    return { name: match[0], version: match[1] };
  }
  const browserSpecs: BrowserSpecs = checkBrowser();

  /**
   *  Функция для дебага, выводит в консоль текущий статус плагина.
   */
  function cpcsp_console_log(
    level: number | undefined,
    msg?: string | undefined
  ) {
    if (
      level &&
      cadesplugin.current_log_level &&
      level <= cadesplugin.current_log_level
    ) {
      if (level === cadesplugin.LOG_LEVEL_DEBUG) {
        console.log("DEBUG: %s", msg);
      }

      if (level === cadesplugin.LOG_LEVEL_INFO) {
        console.info("INFO: %s", msg);
      }

      if (level === cadesplugin.LOG_LEVEL_ERROR) {
        console.error("ERROR: %s", msg);
      }
    }
  }

  /**
   *  Устанавливает уровень логирования в log_level.
   *  Аргумент может принимать значения cadesplugin.LOG_LEVEL_DEBUG (отладочные, информационные сообщения и ошибки),
   *  cadesplugin.LOG_LEVEL_INFO(информационные сообщения и ошибки), cadesplugin.LOG_LEVEL_ERROR(только ошибки).
   */
  function set_log_level(level: number | undefined) {
    if (
      !(
        level === cadesplugin.LOG_LEVEL_DEBUG ||
        level === cadesplugin.LOG_LEVEL_INFO ||
        level === cadesplugin.LOG_LEVEL_ERROR
      )
    ) {
      cpcsp_console_log(
        cadesplugin.LOG_LEVEL_ERROR,
        `cadesplugin_api.js: Incorrect log_level: ${level}`
      );
      return;
    }
    cadesplugin.current_log_level = level;
    if (cadesplugin.current_log_level === cadesplugin.LOG_LEVEL_DEBUG) {
      cpcsp_console_log(
        cadesplugin.LOG_LEVEL_INFO,
        "cadesplugin_api.js: log_level = DEBUG"
      );
    }
    if (cadesplugin.current_log_level === cadesplugin.LOG_LEVEL_INFO) {
      cpcsp_console_log(
        cadesplugin.LOG_LEVEL_INFO,
        "cadesplugin_api.js: log_level = INFO"
      );
    }
    if (cadesplugin.current_log_level === cadesplugin.LOG_LEVEL_ERROR) {
      cpcsp_console_log(
        cadesplugin.LOG_LEVEL_INFO,
        "cadesplugin_api.js: log_level = ERROR"
      );
    }

    if (isNativeMessagingSupported()) {
      if (cadesplugin.current_log_level === cadesplugin.LOG_LEVEL_DEBUG) {
        window.postMessage("set_log_level=debug", "*");
      }

      if (cadesplugin.current_log_level === cadesplugin.LOG_LEVEL_INFO) {
        window.postMessage("set_log_level=info", "*");
      }

      if (cadesplugin.current_log_level === cadesplugin.LOG_LEVEL_ERROR) {
        window.postMessage("set_log_level=error", "*");
      }
    } else {
      pluginLoadedError("Ваш браузер не поддерживается");
    }
  }

  /**
   *  Функция задающая дефолтные значения, используемые в работе плагина.
   */
  function setConstantValues() {
    cadesplugin.CAPICOM_MEMORY_STORE = 0;
    cadesplugin.CAPICOM_LOCAL_MACHINE_STORE = 1;
    cadesplugin.CAPICOM_CURRENT_USER_STORE = 2;
    cadesplugin.CADESCOM_MEMORY_STORE = 0;
    cadesplugin.CADESCOM_LOCAL_MACHINE_STORE = 1;
    cadesplugin.CADESCOM_CURRENT_USER_STORE = 2;
    cadesplugin.CADESCOM_CONTAINER_STORE = 100;

    cadesplugin.CAPICOM_MY_STORE = "My";
    cadesplugin.CAPICOM_ROOT_STORE = "Root";

    cadesplugin.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED = 2;

    cadesplugin.CAPICOM_CERTIFICATE_FIND_SUBJECT_NAME = 1;

    cadesplugin.CADESCOM_XML_SIGNATURE_TYPE_ENVELOPED = 0;
    cadesplugin.CADESCOM_XML_SIGNATURE_TYPE_ENVELOPING = 1;
    cadesplugin.CADESCOM_XML_SIGNATURE_TYPE_TEMPLATE = 2;

    cadesplugin.CADESCOM_XADES_DEFAULT = 0x00000010;
    cadesplugin.CADESCOM_XADES_BES = 0x00000020;
    cadesplugin.CADESCOM_XADES_T = 0x00000050;
    cadesplugin.CADESCOM_XADES_X_LONG_TYPE_1 = 0x000005d0;
    cadesplugin.CADESCOM_XMLDSIG_TYPE = 0x00000000;

    cadesplugin.XmlDsigGost3410UrlObsolete =
      "http://www.w3.org/2001/04/xmldsig-more#gostr34102001-gostr3411";
    cadesplugin.XmlDsigGost3411UrlObsolete =
      "http://www.w3.org/2001/04/xmldsig-more#gostr3411";
    cadesplugin.XmlDsigGost3410Url =
      "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34102001-gostr3411";
    cadesplugin.XmlDsigGost3411Url =
      "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr3411";

    cadesplugin.XmlDsigGost3411Url2012256 =
      "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34112012-256";
    cadesplugin.XmlDsigGost3410Url2012256 =
      "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34102012-gostr34112012-256";
    cadesplugin.XmlDsigGost3411Url2012512 =
      "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34112012-512";
    cadesplugin.XmlDsigGost3410Url2012512 =
      "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34102012-gostr34112012-512";

    cadesplugin.CADESCOM_CADES_DEFAULT = 0;
    cadesplugin.CADESCOM_CADES_BES = 1;
    cadesplugin.CADESCOM_CADES_T = 0x5;
    cadesplugin.CADESCOM_CADES_X_LONG_TYPE_1 = 0x5d;
    cadesplugin.CADESCOM_PKCS7_TYPE = 0xffff;

    cadesplugin.CADESCOM_ENCODE_BASE64 = 0;
    cadesplugin.CADESCOM_ENCODE_BINARY = 1;
    cadesplugin.CADESCOM_ENCODE_ANY = -1;

    cadesplugin.CAPICOM_CERTIFICATE_INCLUDE_CHAIN_EXCEPT_ROOT = 0;
    cadesplugin.CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN = 1;
    cadesplugin.CAPICOM_CERTIFICATE_INCLUDE_END_ENTITY_ONLY = 2;

    cadesplugin.CAPICOM_CERT_INFO_SUBJECT_SIMPLE_NAME = 0;
    cadesplugin.CAPICOM_CERT_INFO_ISSUER_SIMPLE_NAME = 1;

    cadesplugin.CAPICOM_CERTIFICATE_FIND_SHA1_HASH = 0;
    cadesplugin.CAPICOM_CERTIFICATE_FIND_SUBJECT_NAME = 1;
    cadesplugin.CAPICOM_CERTIFICATE_FIND_ISSUER_NAME = 2;
    cadesplugin.CAPICOM_CERTIFICATE_FIND_ROOT_NAME = 3;
    cadesplugin.CAPICOM_CERTIFICATE_FIND_TEMPLATE_NAME = 4;
    cadesplugin.CAPICOM_CERTIFICATE_FIND_EXTENSION = 5;
    cadesplugin.CAPICOM_CERTIFICATE_FIND_EXTENDED_PROPERTY = 6;
    cadesplugin.CAPICOM_CERTIFICATE_FIND_APPLICATION_POLICY = 7;
    cadesplugin.CAPICOM_CERTIFICATE_FIND_CERTIFICATE_POLICY = 8;
    cadesplugin.CAPICOM_CERTIFICATE_FIND_TIME_VALID = 9;
    cadesplugin.CAPICOM_CERTIFICATE_FIND_TIME_NOT_YET_VALID = 10;
    cadesplugin.CAPICOM_CERTIFICATE_FIND_TIME_EXPIRED = 11;
    cadesplugin.CAPICOM_CERTIFICATE_FIND_KEY_USAGE = 12;

    cadesplugin.CAPICOM_DIGITAL_SIGNATURE_KEY_USAGE = 128;

    cadesplugin.CAPICOM_PROPID_ENHKEY_USAGE = 9;

    cadesplugin.CAPICOM_OID_OTHER = 0;
    cadesplugin.CAPICOM_OID_KEY_USAGE_EXTENSION = 10;

    cadesplugin.CAPICOM_EKU_CLIENT_AUTH = 2;
    cadesplugin.CAPICOM_EKU_SMARTCARD_LOGON = 5;
    cadesplugin.CAPICOM_EKU_OTHER = 0;

    cadesplugin.CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0;
    cadesplugin.CAPICOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME = 1;
    cadesplugin.CAPICOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_DESCRIPTION = 2;
    cadesplugin.CADESCOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0;
    cadesplugin.CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME = 1;
    cadesplugin.CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_DESCRIPTION = 2;
    cadesplugin.CADESCOM_ATTRIBUTE_OTHER = -1;

    cadesplugin.CADESCOM_STRING_TO_UCS2LE = 0;
    cadesplugin.CADESCOM_BASE64_TO_BINARY = 1;

    cadesplugin.CADESCOM_DISPLAY_DATA_NONE = 0;
    cadesplugin.CADESCOM_DISPLAY_DATA_CONTENT = 1;
    cadesplugin.CADESCOM_DISPLAY_DATA_ATTRIBUTE = 2;

    cadesplugin.CADESCOM_ENCRYPTION_ALGORITHM_RC2 = 0;
    cadesplugin.CADESCOM_ENCRYPTION_ALGORITHM_RC4 = 1;
    cadesplugin.CADESCOM_ENCRYPTION_ALGORITHM_DES = 2;
    cadesplugin.CADESCOM_ENCRYPTION_ALGORITHM_3DES = 3;
    cadesplugin.CADESCOM_ENCRYPTION_ALGORITHM_AES = 4;
    cadesplugin.CADESCOM_ENCRYPTION_ALGORITHM_GOST_28147_89 = 25;

    cadesplugin.CADESCOM_HASH_ALGORITHM_SHA1 = 0;
    cadesplugin.CADESCOM_HASH_ALGORITHM_MD2 = 1;
    cadesplugin.CADESCOM_HASH_ALGORITHM_MD4 = 2;
    cadesplugin.CADESCOM_HASH_ALGORITHM_MD5 = 3;
    cadesplugin.CADESCOM_HASH_ALGORITHM_SHA_256 = 4;
    cadesplugin.CADESCOM_HASH_ALGORITHM_SHA_384 = 5;
    cadesplugin.CADESCOM_HASH_ALGORITHM_SHA_512 = 6;
    cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411 = 100;
    cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256 = 101;
    cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_512 = 102;
    cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_HMAC = 110;
    cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256_HMAC = 111;
    cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_512_HMAC = 112;

    cadesplugin.LOG_LEVEL_DEBUG = 4;
    cadesplugin.LOG_LEVEL_INFO = 2;
    cadesplugin.LOG_LEVEL_ERROR = 1;

    cadesplugin.CADESCOM_AllowNone = 0;
    cadesplugin.CADESCOM_AllowNoOutstandingRequest = 0x1;
    cadesplugin.CADESCOM_AllowUntrustedCertificate = 0x2;
    cadesplugin.CADESCOM_AllowUntrustedRoot = 0x4;
    cadesplugin.CADESCOM_SkipInstallToStore = 0x10000000;
    cadesplugin.CADESCOM_InstallCertChainToContainer = 0x20000000;
    cadesplugin.CADESCOM_UseContainerStore = 0x40000000;

    cadesplugin.ContextUser = 0x1;

    cadesplugin.ENABLE_CARRIER_TYPE_CSP = 0x01;
    cadesplugin.ENABLE_CARRIER_TYPE_FKC_NO_SM = 0x02;
    cadesplugin.ENABLE_CARRIER_TYPE_FKC_SM = 0x04;
    cadesplugin.ENABLE_ANY_CARRIER_TYPE = 0x07;

    cadesplugin.DISABLE_EVERY_CARRIER_OPERATION = 0x00;
    cadesplugin.ENABLE_CARRIER_OPEN_ENUM = 0x01;
    cadesplugin.ENABLE_CARRIER_CREATE = 0x02;
    cadesplugin.ENABLE_ANY_OPERATION = 0x03;

    cadesplugin.CADESCOM_PRODUCT_CSP = 0;
    cadesplugin.CADESCOM_PRODUCT_OCSP = 1;
    cadesplugin.CADESCOM_PRODUCT_TSP = 2;

    cadesplugin.MEDIA_TYPE_REGISTRY = 0x00000001;
    cadesplugin.MEDIA_TYPE_HDIMAGE = 0x00000002;
    cadesplugin.MEDIA_TYPE_CLOUD = 0x00000004;
    cadesplugin.MEDIA_TYPE_SCARD = 0x00000008;

    cadesplugin.XCN_CRYPT_STRING_BASE64HEADER = 0;
    cadesplugin.AT_KEYEXCHANGE = 1;
    cadesplugin.AT_SIGNATURE = 2;
    cadesplugin.XCN_CRYPT_STRING_BASE64_ANY = 0x6;
    cadesplugin.XCN_CRYPT_STRING_ANY = 0x7;
  }

  /**
   *  Функция принимающая на вход функцию генератор и позволяющая "синхронизировать"
   *  асинхронную работу с Promise при использовании совместно с ключевым словом yield.
   */
  function async_spawn<T>(
    generatorFunc: (...args: unknown[]) => Iterator<T>
  ): T {
    let onFulfilled: <T extends string | number | object | undefined>(
      arg?: T
    ) => Promise<T> | undefined = continuer.bind(continuer, "next");

    let onRejected: <T extends string | number | object | undefined>(
      arg?: T
    ) => Promise<T> | undefined = continuer.bind(continuer, "throw");

    let generator = generatorFunc(Array.prototype.slice.call(arguments, 1));

    function continuer(
      verb: string,
      arg?: string | number | object | undefined
    ) {
      let result: {
        value: Promise<string | number | object | undefined>;
        done: boolean;
      };
      try {
        // @ts-ignore
        result = generator[verb](arg);
      } catch (err) {
        return Promise.reject(err);
      }
      if (result.done) {
        return result.value;
      }
      return Promise.resolve(result.value).then(onFulfilled, onRejected);
    }
    // @ts-ignore
    return onFulfilled();
  }

  /**
   *  Проверка поддержки Native Messaging в браузере.
   *  (https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/Native_messaging)
   */
  function isNativeMessagingSupported() {
    const version = Number(browserSpecs.version);
    if (browserSpecs.name === "Edg") {
      return true;
    }
    if (browserSpecs.name === "YaBrowser") {
      isYandex = true;
      return true;
    }

    if (browserSpecs.name === "Opera") {
      isOpera = true;
      if (version >= 33) {
        return true;
      }

      return false;
    }
    if (browserSpecs.name === "Firefox") {
      isFireFox = true;
      if (version >= 52) {
        return true;
      }

      return false;
    }
    if (browserSpecs.name === "Chrome") {
      if (version >= 42) {
        return true;
      }

      return false;
    }
    // В Сафари начиная с 12 версии есть Native Messaging.
    if (browserSpecs.name === "Safari") {
      isSafari = true;
      if (version >= 12) {
        return true;
      }
      return false;
    }
  }

  /**
   *  Функция приводящая число к HEX.
   */
  function decimalToHexString(number: number): string {
    if (number < 0) {
      number = 0xffffffff + number + 1;
    }
    return number.toString(16).toUpperCase();
  }

  /**
   *  Функция вывода кода или сообщения об ошибке из объекта с ошибкой.
   */
  function getMessageFromException(exception: PluginException): string {
    if (exception.message && exception.number) {
      return `${exception.message} (0x${decimalToHexString(exception.number)})`;
    } else if (exception.message) {
      return exception.message;
    } else if (exception.number) {
      return `(0x${decimalToHexString(exception.number)})`;
    } else {
      return "Undefined error";
    }
  }

  /**
   *  Возвращает строку с описанием ошибки из исключения, порождённого плагином.
   *  Для Firefox данный метод является единственным способом получения кода ошибки и её текстового описания от плагина.
   */
  function getLastError(exception: PluginException): string {
    if (isNativeMessagingSupported()) {
      return getMessageFromException(exception);
    }

    if (pluginObject.getLastError?.()) {
      return pluginObject.getLastError();
    } else {
      return getMessageFromException(exception);
    }
  }

  /**
   *  Функция для удаления созданных объектов.
   */
  function ReleasePluginObjects(): Promise<boolean> {
    // @ts-ignore
    return cpcsp_chrome_nmcades.ReleasePluginObjects();
  }

  /**
   *  Cоздает обьект с помощью одного из интерфейсов,
   *  указанных в CADES_Plugin.ObjectNamesAsync и возвращает Promise на созданный обьект.
   */
  function CreateObjectAsync<T extends keyof CADES_Plugin.ObjectNamesAsync>(
    name: T
  ): Promise<CADES_Plugin.ObjectNamesAsync[T]> {
    return pluginObject.CreateObjectAsync!(name);
  }

  /**
   *  Функция отправляющая событие со ссылкой на nmcades_plugin_api.js.
   *  Инициирует загрузку и выполнение данного файла.
   */
  function firefoxOrSafariNmcadesPluginApiOnload() {
    // @ts-ignore
    cpcsp_chrome_nmcades.check_chrome_plugin(pluginLoaded, pluginLoadedError);
  }

  /**
   *  Функция установки обработчика на событие cadesplugin_loaded.
   */
  function nmcadesPluginApiOnload() {
    let timeoutId: ReturnType<typeof setTimeout>;

    const cadespluginLoadedListener = (event: PluginLoadedEvent) => {
      if (
        typeof event.data !== "string" ||
        !event.data.match("cadesplugin_loaded")
      ) {
        return;
      }

      if (isCadespluginLoadedEventRecieved) {
        return;
      }

      if (isFireFox || isSafari) {
        clearTimeout(timeoutId);

        // Для Firefox, Сафари вместе с сообщением cadesplugin_loaded прилетает url для загрузки nmcades_plugin_api.js
        const url = event.data.substring(event.data.indexOf("url:") + 4);

        if (
          !url.match(
            "^(moz|safari)-extension://[a-zA-Z0-9/_-]+/nmcades_plugin_api.js$"
          )
        ) {
          cpcsp_console_log(
            cadesplugin.LOG_LEVEL_ERROR,
            `Bad url "${url}" for load CryptoPro Extension for CAdES Browser plug-in`
          );
          pluginLoadedError();
          return;
        }

        const fileref = document.createElement("script");

        fileref.setAttribute("type", textJavascript);
        fileref.setAttribute("src", url);
        fileref.onerror = pluginLoadedError;
        fileref.onload = firefoxOrSafariNmcadesPluginApiOnload;

        document.getElementsByTagName("head")[0].appendChild(fileref);
      } else {
        // @ts-ignore
        cpcsp_chrome_nmcades.check_chrome_plugin(
          pluginLoaded,
          pluginLoadedError
        );
      }

      isCadespluginLoadedEventRecieved = true;
    };

    // В браузере Safari и Firefox мы не знаем адрес по которому находится расширение и его файл nmcades_plugin_api.js.
    // В данных браузерах мы ожидаем появление события cadesplugin_loaded (см. cadespluginLoadedListener),
    // в котором будет ссылка на вышеуказанный js-файл для его загрузки и последующего исполнения.
    //
    // Если у пользователя не устанавлено расширение в принципе, то мы никогда не дождемся появления события cadesplugin_loaded,
    // а значит не зарезолвим промис cadesplugin и не вернем управление прикладному коду проекта Логина.
    //
    // Для этого мы устанавливаем timeout для процесса ожидания события cadesplugin_loaded в браузерах Safari и Firefox (см. cadespluginLoadedListener).
    // Если прошло 5 секунд и в cadespluginLoadedListener событие cadesplugin_loaded не появилось,
    // то принимаем решение что у пользователя в вышеуказанных браузерах не установлено расширение.
    // В результате чего вызываем pluginLoadedError, reject'им промис и возвращаем управление прикладному коду проекта Логина.
    if (!isCadespluginLoadedEventRecieved && (isFireFox || isSafari)) {
      timeoutId = setTimeout(() => {
        window.removeEventListener("message", cadespluginLoadedListener);
        pluginLoadedError();
      }, 5000);
    }

    window.postMessage("cadesplugin_echo_request", "*");
    window.addEventListener("message", cadespluginLoadedListener, false);
  }

  /**
   *  Функция загрузки расширения.
   */
  function loadExtension() {
    if (isFireFox || isSafari) {
      // Получаем ID расширения, так как он уникальный для браузера.
      nmcadesPluginApiOnload();
    } else if (isOpera || isYandex) {
      // в асинхронном варианте для Yandex и Opera подключаем расширение из Opera store.
      var fileref = document.createElement("script");
      fileref.setAttribute("type", textJavascript);
      fileref.setAttribute(
        "src",
        "chrome-extension://epebfcehmdedogndhlcacafjaacknbcm/nmcades_plugin_api.js"
      );
      fileref.onerror = pluginLoadedError;
      fileref.onload = nmcadesPluginApiOnload;
      document.getElementsByTagName("head")[0].appendChild(fileref);
    } else {
      // для Chrome, Chromium, Chromium Edge расширение из Chrome store.
      var fileref = document.createElement("script");
      fileref.setAttribute("type", textJavascript);
      fileref.setAttribute(
        "src",
        "chrome-extension://iifchhfnnmpdbibifmljnfjhpififfog/nmcades_plugin_api.js"
      );
      fileref.onerror = pluginLoadedError;
      fileref.onload = nmcadesPluginApiOnload;
      document.getElementsByTagName("head")[0].appendChild(fileref);
    }
  }

  /**
   *  Функция уведомления об успешно установленном плагине.
   */
  function pluginLoaded() {
    isPluginResolved = true;
    pluginResolve();
  }

  /**
   *  Функция уведомления об ошибке взаимодействия с плагином.
   */
  function pluginLoadedError(msg?: string | undefined | object) {
    if (typeof msg === "undefined" || typeof msg === "object") {
      msg = "Плагин недоступен";
    }
    isPluginResolved = true;
    pluginReject(msg);
  }

  /**
   *  Функция проверки работы плагина.
   */
  function checkPluginWorking() {
    if (isNativeMessagingSupported()) {
      loadExtension();
    } else {
      pluginLoadedError("Ваш браузер не поддерживается");
    }
  }

  setConstantValues();

  /**
   *  Функция установки pluginObject.
   */
  function set_pluginObject(obj: object) {
    pluginObject = obj;
  }

  /**
   *  Функция проверки доступности интерфейса CAPILite.
   */
  function is_capilite_enabled() {
    if (
      typeof cadesplugin.EnableInternalCSP !== "undefined" &&
      cadesplugin.EnableInternalCSP
    ) {
      return true;
    }
    return false;
  }

  // Экспорт написанных функций в плагин.
  cadesplugin.JSModuleVersion = "2.3.1";
  cadesplugin.async_spawn = async_spawn;
  cadesplugin.set = set_pluginObject;
  cadesplugin.set_log_level = set_log_level;
  cadesplugin.getLastError = getLastError;
  cadesplugin.is_capilite_enabled = is_capilite_enabled;

  if (isNativeMessagingSupported()) {
    cadesplugin.CreateObjectAsync = CreateObjectAsync;
    cadesplugin.ReleasePluginObjects = ReleasePluginObjects;
  } else {
    pluginLoadedError("Ваш браузер не поддерживается");
  }

  cadesplugin.current_log_level = cadesplugin.LOG_LEVEL_ERROR;
  // @ts-ignore
  window.cadesplugin = cadesplugin;

  // В настройках расширения CryptoProExtension (в браузерах Chrome, Yandex и Opera) существует опция для запуска
  // экстеншена только после клика на него, что дает разрешение для его работы на странице.
  // Если расширение не имеет доступа к странице, то прикладной код проекта Логина не сможет запустить процесс
  // проверки информации о криптопровайдере, получить список сертификатов пользователя и тд.
  //
  // Кроме того, в процессе загрузки страницы Логина существует логика отображения лоадера и текста с просьбой
  // включить расширение, если мы продолжительное время не получаем ответа от промиса cadesplugin.
  //
  // Прежде чем отображать данный текст и показывать лоадер, мы должны убедиться что у пользователя данное расширение
  // установлено, поскольку он может вовсе не использовать вход по токену, а значит не использовать расширение в принципе.
  //
  // Для этих целей мы устанавливаем обработчик наблюдающий за отправкой сообщения "EnableInternalCSP=...".
  // Данное сообщение отправляет код из js-файла (nmcades_plugin_api.js) загружаемого из расширения (см. функции loadExtension и nmcadesPluginApiOnload).
  // Вероятно это не самый надежный способ проверки наличия расширения, но других способов найдено не было.
  //
  // После обнаружения такого события, мы вызываем функцию isPluginInstalledCallback получаемую из прикладного кода,
  // что просигнализирует коду проекта Логина о том, что мы определили установленное расширение у пользователя
  // и ему можно отобразить соответствующий текст с просьбой активировать его для продолжения работы в проекте.
  window.addEventListener( // NOSONAR
    "message",
    (event) => {
      if (
        isPluginInstalledCallback &&
        !isPluginResolved &&
        !isCadespluginInstalled &&
        typeof event.data === "string" &&
        event.data.startsWith("EnableInternalCSP=")
      ) {
        isCadespluginInstalled = true;
        isPluginInstalledCallback(true);
      }
    }
  );

  checkPluginWorking();
  return cadesplugin as CadesPluginAsync;
};
